const NG_WebPortal = require('./../../../shared/scripts/webportal');

$(function () {

    //alert("This is the shared/components/webportal");


    document.addEventListener('LOGGEDIN', function (e) {
        //console.log("LOGGEDIN event listened to: ", e);

    });
    document.addEventListener('LOGGINGIN', function (e) {
        //console.log("LOGGINGIN event listened to: ", e);

        if (e.detail.showAlertSignup) {
            if (window.location.href.toUpperCase().indexOf("APP_REGISTRATION") > -1) {
                location.href = '/app_registration/thankyou';
            }
            else {
                NG_WebPortal.Display.showAlertSignupModal();
            }
        }
        else {
            //alert("Url  =" + document.location);// rcw testing only
            //alert("PathName  =" + window.location.pathname);// Returns path only // rcw testing only
            //alert("url  =" + window.location.href);// Returns full URL // rcw testing only

            var i;
            var sPathname = window.location.href;
            var sSplit = sPathname.split("/");
            for (i = 0; i < sSplit.length; i++) {
                //document.write("<br /> Element " + i + " = " + sSplit[i]);                				
                switch (i) {
                    case 0:
                        var path = sSplit[0];
                        // if (path == "promo") { location.reload(); }
                        //if (path == "Raffle") { location.reload(); }
						//alert("PathName0  =" + path);
                        break;
                    case 1:
                        var path = sSplit[1];
                        //if (path == "promo") { location.reload(); }
                        //if (path == "Raffle") { location.reload(); }
						//alert("PathName1  =" + path);

                        break;
                    case 2:
                        var path = sSplit[2];
                        // if (path == "promo") { location.reload(); }
                        //if (path == "Raffle") { location.reload(); }
						//alert("PathName2  =" + path);

                        break;
                    case 3:
                        var path = sSplit[3];
                        //if (path == "Raffle") { location.reload(); }
                        // if (path == "promo") { location.reload(); }
                        if (path == "alerts") { location.reload(); }
                        if (path == "Alerts") { location.reload(); }
                        //if (path == "Raffle") { location.reload(); }
                        //if (path == "raffle") { location.reload(); }
                        //if (path == "Data") { location.reload(); }
                        //if (path == "Draw-Games") { location.reload(); }

                        break;
                    case 4:
                        var path = sSplit[4];
                        //if (path == "Raffle") { location.reload(); }
                        if (path == "promo") { location.reload(); }
                        //if (path == "Raffle") { location.reload(); }
                        //if (path == "raffle") { location.reload(); }
                        //if (path == "Data") { location.reload(); }
                        //if (path == "Draw-Games") { location.reload(); }

                        break;
                    case 5:
                        var path = sSplit[5];
                        if (path == "Raffle") { location.reload(); }
						if (path == "raffle") { location.reload(); }
                        //if (path == "promo") { location.reload(); }
                        //if (path == "Raffle") { location.reload(); }
                        //if (path == "raffle") { location.reload(); }
                        //if (path == "Draw-Games") { location.reload(); }

                        break;
                    case 6:
                        var path = sSplit[6];
						//alert("PathName6  =" + path);
                        //if (path == "Raffle") { location.reload(); }
                        // if (path == "promo") { location.reload(); }
                        //if (path == "Raffle") { location.reload(); }
                        //if (path == "raffle") { location.reload(); }
                        //if (path == "Draw-Games") { location.reload(); }

                        break;
                }
            }
            //location.reload();  //old.. RCW
        }
    });
    document.addEventListener('LOGGINGOUT', function (e) {

        //console.log("LOGGINGOUT event listened to: ", e);
        //Delay reloading page until NPI logout/sessiontimeout modal is shown for x seconds
        setTimeout(function () {
            location.reload();
        }, 3000);
    });

    document.addEventListener('LOGGEDOUT', function (e) {
        //console.log("LOGGEDOUT event listened to: ", e);

    });

    //Try to update display with previous session data while ng_fw initializes
    if (NG_WebPortal.SessionStore.hasSessionInStore()) {

        let sessionStoreValues = NG_WebPortal.SessionStore.getSessionStoreValues();
        NG_WebPortal.Display.updateWPTopBarItems(sessionStoreValues);

    }
    //------------------ This is for  loading the Game  This may be in the wrong place ----------------------//
    // Wait untill NG framework being initialized - then framework's api will be available

    document.addEventListener('fwReady', function () {
        //alert("hey Ray, This is the webportal-instant-game");
		
		// RCW 07/16/2020 update the shopping cart
         ng_hs.shoppingCartStatusUpdated(function(status) {
		    $('#wp-shopping-cart #shopping-cart-item-counter').html(status.IsError ? '!' : `(${status.NumberOfItems})`);
	      })
		  
        var isStandaloneGameMode = window.getFrameworkPreferences().IsGameStandaloneMode;
        var unsubscribeGameDimsChange;

        ng_hs.instantGame.gameLoadStart(function (gid, mode) {
            console.log('instantGame.gameLoadStart', gid, mode);
            if (isStandaloneGameMode || mode === 'R') {
                return;
            }

            unsubscribeGameDimsChange = subscribeGameDimsChange(getInstantGameAspectRatio(gid));

            //loadGameBackground(gid);
            showGameContainer();
        });
            // RCW 07/16/2020 Changed mode==='R' to gameMode==='R'
        ng_hs.instantGame.gameClosed(function (gameId, gameMode) {
            console.log('instantGame.gameClosed', gameId, gameMode);

            if (isStandaloneGameMode || gameMode === 'R') {
                return;
            }

            hideGameContainer();
            //unloadGameBackground();
            //unsubscribeGameDimsChange();
        });

        ng_hs.instantGame.gameRoundStarted(function (gameId, gameMode) {
            console.log('instantGame.gameRoundStarted', gameId, gameMode);
        });

        ng_hs.instantGame.gameRoundEnded(function (gameId, gameMode, data) {
            console.log('instantGame.gameRoundEnded', gameId, gameMode, data);
        });

        ng_hs.instantGame.autoplayStarted(function (gameId, gameMode) {
            console.log('instantGame.autoplayStarted', gameId, gameMode);
        });

        ng_hs.instantGame.autoplayStopped(function (gameId, gameMode) {
            console.log('instantGame.autoplayStopped', gameId, gameMode);
        });

        ng_hs.instantGame.freeSpinStarted(function (gameId, gameMode) {
            console.log('instantGame.freeSpinStarted', gameId, gameMode);
        });

        ng_hs.instantGame.freeSpinEnded(function (gameId, gameMode) {
            console.log('instantGame.freeSpinEnded', gameId, gameMode);
        });

        ng_hs.instantGame.bonusGameStarted(function (gameId, gameMode) {
            console.log('instantGame.bonusGameStarted', gameId, gameMode);
        });

        ng_hs.instantGame.bonusGameEnded(function (gameId, gameMode) {
            console.log('instantGame.bonusGameEnded', gameId, gameMode);
        });

        //TODO: Temporary for testing only - change on ng_fw call when API will be developed
        $('.wp-replay-instant-game-btn').click(function () {
            angular.element('#mwc-app').injector().get('lazyLoader')
                .load('instant-game-web')
                .then(function () {
                    angular.element('#mwc-app').injector()
                        .get('instantGameWebLoaderService')
                        .replay($('.wp-replay-instant-game-number').val(), $('.wp-replay-instant-game-id').val());
                });
        });

        $('.wp-open-instant-game-demo-btn').click(function () {
            loadSelectedGame('D');
        });

        $('.wp-open-instant-game-money-btn').click(function () {
            loadSelectedGame('M');
        });
    });

    $(document).ready(function () {
       // $('#wp-Instant-Games').on('click', '.wp-open-instant-game-demo-btn', function () {
         //   ng_fw.loadGame($(this).attr('data-gameid'), 'D');
       // });

       // $('#wp-Instant-Games').on('click', '.wp-open-instant-game-money-btn', function () {
        //    ng_fw.loadGame($(this).attr('data-gameid'), 'M');
       // });

        //-------Added on 05/13/2020----------//
        $('.wp-instant-game-close-button').click(function () {
            ng_fw.closeGame();
            hideGameContainer();
        });
        
		 //-------Added on 05/26/2020----------//
		 $('#wp-Instant-Games').on('click', '.wp-open-instant-all-games-btn', function () {
            window.open("/instants", "_top", "");
        });
		
		//--------------End-------------------// 
    });
    function loadSelectedGame(playMode) {
        var selectedGameId = $('.wp-open-instant-game-number').val();
        ng_fw.loadGame(selectedGameId, playMode);
    }

    function subscribeGameDimsChange(aspectRatio) {
        return instantGameDimsService.onDimsChange(aspectRatio, updateGameDimensions);
    }

    function updateGameDimensions(dim) {
        $('.wp-instant-game-content-game').css({
            'height': dim.height + 'px',
            'width': dim.width + 'px',
            'margin-top': dim.marginTop + 'px'
        });
    }

    function getInstantGameAspectRatio(gid) {
        return getInstantGameData(gid).aspectRatio;
    }

    function getInstantGameBackgroundUrl(gid) {
        return getInstantGameData(gid).backgroundImageUrl;
    }

    function getInstantGameData(gid) {
        return ng_fw.getGamesList().games.instant.filter(function (game) {
            return game.id === Number(gid);
        })[0];
    }

    function showGameContainer() {
        $('.wp-instant-game-container').show();
    }

    function hideGameContainer() {
        $('.wp-instant-game-container').hide();
    }

    function loadGameBackground(gid) {
        $('.wp-instant-game-background').preLoadBackgroundImg(getInstantGameBackgroundUrl(gid));
    }

    function unloadGameBackground() {
        $('.wp-instant-game-background').unLoadBackgroundImg();
    }

    $.fn.preLoadBackgroundImg = function (url) {
        var element = this;
        $('<img/>').attr('src', url).load(function () {
            $(this).remove();

            element.css('background-image', 'url(' + url + ')')
                .animate({ opacity: 1 }, 700);
        });
    };

    $.fn.unLoadBackgroundImg = function () {
        this.css({
            'background-image': '',
            opacity: 0
        });
    };

    var instantGameDimsService = (function () {
        var CONTAINER_X_PADDING = 120;
        var CONTAINER_Y_PADDING = 100;
        var ACTION_BAR_HEIGHT = 60;

        var MAX_HEIGHT = 650;
        var MIN_HEIGHT = 476;

        return {
            onDimsChange: onDimsChange
        };

        function calculateBoundaries(aspectRatio) {
            return {
                MAX: {
                    WIDTH: MAX_HEIGHT * aspectRatio,
                    HEIGHT: MAX_HEIGHT
                },
                MIN: {
                    WIDTH: MIN_HEIGHT * aspectRatio,
                    HEIGHT: MIN_HEIGHT
                }
            };
        }

        function onDimsChange(aspectRatio, subscriber) {
            var boundaries = calculateBoundaries(aspectRatio);

            function onResize() {
                subscriber(getFitDims(boundaries));
            }

            onResize();

            $(window).on('resize', onResize);
            return function () {
                $(window).off('resize', onResize);
            };
        }

        function getFitDims(boundaries) {
            var width;
            var height;

            var available = getAvailableDims();

            var marginTop;

            if (boundaries.MAX.HEIGHT > available.height || boundaries.MAX.WIDTH > available.width) {
                var scaled = getScaledDims(boundaries, available);

                if (scaled.width <= available.width) {
                    width = scaled.width;
                    height = available.height;
                } else {
                    height = scaled.height;
                    width = available.width;
                }

                if (height < boundaries.MIN.HEIGHT || width < boundaries.MIN.WIDTH) {
                    height = boundaries.MIN.HEIGHT;
                    width = boundaries.MIN.WIDTH;
                }
            } else {
                width = boundaries.MAX.WIDTH;
                height = boundaries.MAX.HEIGHT;
            }

            marginTop = (available.height - height) / 2 + (CONTAINER_Y_PADDING / 2);

            return {
                width: width,
                height: height,
                marginTop: marginTop
            };
        }

        function getAvailableDims() {
            var headerHeight = $('.mwc-instant-game-web-header').height();

            return {
                height: document.documentElement.clientHeight - headerHeight - ACTION_BAR_HEIGHT - CONTAINER_Y_PADDING,
                width: document.documentElement.clientWidth - CONTAINER_X_PADDING
            };
        }

        function getScaledDims(bound, available) {
            return {
                width: Math.round(bound.MAX.WIDTH * (available.height / bound.MAX.HEIGHT)),
                height: Math.round(bound.MAX.HEIGHT * (available.width / bound.MAX.WIDTH))
            };
        }
    })();


    //-------------------------------- END -------------------------------------------------//
    // NG framework emits this event after being initialized - need to wait for this.
    $(document).on('fwReady', function () {

        //Initialize iLottery Games list
       // initGameListContainer();

        //Initialize top bar
        var ngSession = NG_WebPortal.SessionStore.getSessionDetails();
        var currentSessionStore = NG_WebPortal.SessionStore.getSessionStoreValues();
        //NG_WebPortal.SessionStore.emitSessionStatusChangeEvent(ngSession);
        NG_WebPortal.SessionStore.updateSessionStore(ngSession, currentSessionStore);
        NG_WebPortal.Display.updateWPTopBarItems(ngSession);
        NG_WebPortal.Display.updateWPTopBarCart(ngSession);
        //NG_WebPortal.WPKeepAlive(ngSession); // Keep alive Testing

        //Used NG framework API listen to user's session update
        ng_hs.onSessionStatusUpdate(function () {
            //Reinitialize top bar
            var ngSession = NG_WebPortal.SessionStore.getSessionDetails();
            var currentSessionStore = NG_WebPortal.SessionStore.getSessionStoreValues();
            //NG_WebPortal.SessionStore.emitSessionStatusChangeEvent(ngSession);
            NG_WebPortal.SessionStore.updateSessionStore(ngSession, currentSessionStore);
            NG_WebPortal.Display.updateWPTopBarItems(ngSession);
            NG_WebPortal.Display.updateWPTopBarCart(ngSession);
            // NG_WebPortal.WPKeepAlive(ngSession); // Keep alive Testing
        });


        //------------------ This starts the loading of the Games from the games list 04/28/2020 RCW ----------------------//


        function initGameListContainer() {
            //alert("hey Ray, initGameListContainer"); // This is to test that the function is being executed.				

            var gameContainer = $('#wp-Instant-Games');
            console.log('gameContainer', gameContainer);
            debugger;

            ng_hs.onGamesListUpdated(function (gameList) {
                //widndow.gameList = gameList;   
                console.log("ng_hs.onGamesListUpdated", arguments);

                const gameListContainerEl = document.createElement('div');
			
                gameListContainerEl.setAttribute('class', 'row');

                const gameHeaderEl = document.createElement('div');
                gameHeaderEl.setAttribute('class', 'col-xs-12');
				
				const gameHeadercontainerEl = document.createElement('div');
				gameHeadercontainerEl.setAttribute('class', 'iheader-container');

                var h3 = document.createElement("h3");

                h3.innerText = "PLAY NOW";
                //gameHeaderEl.innerHTML = 'PLAY NOW';
				gameHeaderEl.appendChild(gameHeadercontainerEl);
                gameHeadercontainerEl.appendChild(h3);	
                gameListContainerEl.appendChild(gameHeaderEl);

                //var para = document.createElement("p");
                //para.innerText = "Instant Games";
                //gameHeaderEl.appendChild(para);
                //gameListContainerEl.appendChild(gameHeaderEl);

                console.log('gameList', gameList);
                var i = 0;
				var x;
				var loadgamescount = 8; // default instant games load count
				var minilobby = "true" 
		    
            var sPathname = window.location.href;
            var sSplit = sPathname.split("/");
            for (x = 0; x < sSplit.length; x++) {
                switch (x) {
                    case 0:
                        var path = sSplit[0];
                         if (path == "instants") { loadgamescount = 9999}
						                         //alert("path sSplit array 0 "+path);
                        break;
                    case 1:
                        var path = sSplit[1];
                         if (path == "instants") { loadgamescount = 9999; minilobby = "false"}
						 						 //alert("path sSplit array 1 "+path);

                        break;
                    case 2:
                        var path = sSplit[2];
                         if (path == "instants") { loadgamescount = 9999; minilobby = "false"}
						 						 //alert("path sSplit array 2 "+path);

                        break;
                    case 3:
                        var path = sSplit[3];
                         if (path == "instants") { loadgamescount = 9999;  minilobby = "false"}
						 						 //alert("path sSplit array 3 "+path);

                        break;                      
                }
            }
				
				
                gameList.games.instant.forEach(function (game) {
                    console.log('game', game);
                    // Load only 8 games//			
                    if (i < loadgamescount) {

                        const gameId = game.id;
                        const gameName = game.name;
                        const gameImgUrl = game.images.default;
                        const betDenominations = game.betDenominations;
                        const playModes = game.playModes;
                        const gameConfig = game.gameConfig;
                        const gamePrize = game.maxPrize;

                        const gameItemEl = document.createElement('div');
                        //gameItemEl.setAttribute('id', 'game-'+gameId);
						
                        gameItemEl.setAttribute('class', 'col col-xs-6 col-sm-6 col-md-3');
						const gameDetailsbgEl = document.createElement('div');
                        gameDetailsbgEl.setAttribute('id', 'game-' + gameId);
                        gameDetailsbgEl.setAttribute('class', 'mybg');

                        gameItemEl.appendChild(gameDetailsbgEl);

                        const gameImgEl = document.createElement('img');
                        gameImgEl.setAttribute('class', 'instantgames');
                        gameImgEl.src = gameImgUrl;
                        gameDetailsbgEl.appendChild(gameImgEl);

                        gameConfig.forEach(function (snipes) {
                            if (snipes == 'New') {
                                const gameImgOverEl = document.createElement('img');
                                gameImgOverEl.setAttribute('class', 'over-img');
                                gameImgOverEl.src = "/images/ilottery/ilottery_gamecard_flag_new.png";
                                gameDetailsbgEl.appendChild(gameImgOverEl);
                            }
							if (snipes == 'Free') {
                                const gameImgOverEl = document.createElement('img');
                                gameImgOverEl.setAttribute('class', 'over-img');
                                gameImgOverEl.src = "/images/ilottery/ilottery_gamecard_flag_free.png";
                                gameDetailsbgEl.appendChild(gameImgOverEl);
                            }
                        });

                        const gameNameEl = document.createElement('div');
                        gameNameEl.setAttribute('class', 'instanttxt');
                        gameNameEl.innerHTML = gameName;
                        gameDetailsbgEl.appendChild(gameNameEl);

                        ////const gamemode = '';


                        const prizeEl = document.createElement('div');
                        prizeEl.setAttribute('class', 'instantprize');
                        var Topprize = new Number(gamePrize).toLocaleString("en-US");
                        prizeEl.innerHTML = 'Top Prize: $' + Topprize;

                        gameDetailsbgEl.appendChild(prizeEl);


                        const priceEl = document.createElement('div');
                        priceEl.setAttribute('class', 'instantprice');
                        var priceStart = betDenominations[0];
                        var priceEnd = betDenominations[betDenominations.length - 1];

                        var PriceOne = new Number(priceStart).toLocaleString("en-US");
                        var priceTwo = new Number(priceEnd).toLocaleString("en-US");
                        priceEl.innerHTML = 'Price: $' + PriceOne + ' - $' + priceTwo + '.00';
                        gameDetailsbgEl.appendChild(priceEl);


                        const buttonEl = document.createElement('div');
                        ////buttonEl.setAttribute('class', 'example_d');

                        gameDetailsbgEl.appendChild(buttonEl);
                        playModes.forEach(function (mode) {



                            const gamemode = '';
                            //const button = document.createElement('button');

                            if (mode == 'Demo') {
                                const buttonDemo = document.createElement('button');
                                buttonDemo.setAttribute('class', 'demo_d wp-open-instant-game-demo-btn');
                                buttonDemo.setAttribute('data-gamemode', 'D')
                                buttonDemo.setAttribute('data-gameid', gameId);
                                buttonDemo.setAttribute('data-game-name', gameName);
                                buttonDemo.innerHTML = mode;
                                buttonEl.appendChild(buttonDemo);
                            }
                            if (mode == 'Money') {
                                const buttonPlayNow = document.createElement('button');

                                buttonPlayNow.setAttribute('class', 'play_m wp-open-instant-game-money-btn');
                                buttonPlayNow.setAttribute('data-gamemode', 'M')
                                buttonPlayNow.setAttribute('data-gameid', gameId);
                                buttonPlayNow.setAttribute('data-game-name', gameName)
                                buttonPlayNow.innerHTML = 'Play Now';
                                buttonEl.appendChild(buttonPlayNow);
                            }

                            //buttonDemo.setAttribute('data-gameid', gameId);
                            //buttonDemo.setAttribute('data-game-name', gameName);

                            //button.innerHTML = mode;

                            //buttonEl.appendChild(buttonPlayNow);
                        });

                        //const info = document.createElement('i');
                        //const style = document.createElement('style');
                        //info.setAttribute('class', 'fa');
                        ////info.style.Color = "blue";
                        ////info.style.font-size ="36px";
                        ////buttonEl.appendChild(style);
                        //info.innerHTML = '&#xf05a;';

                        //buttonEl.appendChild(info);

                        gameListContainerEl.appendChild(gameItemEl);

                        i++;
                    }
					

                });
				if (minilobby == "true") {
                const gameFooterEl = document.createElement('div');
                      gameFooterEl.setAttribute('class', 'col-xs-12');
				
				const gameFootercontainerEl = document.createElement('div');
				      gameFootercontainerEl.setAttribute('class', 'ifooter-container');

				  const buttonAll = document.createElement('button');
                                buttonAll.setAttribute('class', 'play_a wp-open-instant-all-games-btn');
                                buttonAll.innerHTML = 'VIEW MORE GAMES >';

                h3.innerText = "PLAY NOW";
				gameFooterEl.appendChild(gameFootercontainerEl);
                gameFootercontainerEl.appendChild(buttonAll);	
                gameListContainerEl.appendChild(gameFooterEl);
					
				}
                console.log('gameListContainerEl', gameListContainerEl);

                gameContainer.html(gameListContainerEl);
				
            });

            var gamelistdata = ng_fw.updateGamesList();
        }
        //------------------ This is the End 05/28/2020 RCW ----------------------//
		
		
		/////---- Clear params event handling----- //////
        ////----
        //ng_hs.clearURLParams(function (keys) {
        //    var result = "";
        //    var query = window.location.search;

        //    if (query[0] === '?') {
        //        query = query.replace('?', '');
        //        result = "?";
        //    }
        //    var params = query.split('&');
        //    if (params.length > 0 && query.length > 0) {
        //        params.forEach(function (param) {
        //            var paramArr = param.split('=');
        //            if (keys.indexOf(paramArr[0]) === -1) {
        //                result += paramArr.join('=') + ("&");
        //            }
        //        });
        //    }

        //    if (result[result.length - 1] === '&') {
        //        result = result.substring(0, result.length - 1);
        //    }

        //    window.history.pushState(null, false, result);
        //});
/////--------------------------- RCW 08/07/2020 ---------------------------------/////

        ng_hs.clearURLParams(function (keys) {

            var result = "";
            var query = window.location.search;

            if (query[0] === '?') {
                query = query.replace('?', '');
                result = "?";
            }
            var params = query.split('&');
            if (params.length > 0 && query.length > 0) {
                params.forEach(function (param) {
                    var paramArr = param.split('=');
                    if (keys.indexOf(paramArr[0]) === -1) {
                        result += paramArr.join('=') + ("&");
                    }
                });
            }

            if (result[result.length - 1] === '&') {
                result = result.substring(0, result.length - 1);
            }

            const modifiedUrl = window.location.pathname + result;

            window.history.replaceState && window.history.replaceState({}, document.title, modifiedUrl)
        });

		
        ng_hs.openPage(function (key, customInfo) {
            //console.log('openPage(' + key + ',' + customInfo + ')');

            var pageKey = key;
            if (customInfo == '500' || customInfo == '502' || customInfo == '506' || customInfo == '500_1.1' || customInfo == '502_1.1' || customInfo == '519'|| customInfo == '3501'|| customInfo == '3502'|| customInfo == 'bycredit' || customInfo == 'ach-banktransfer' || customInfo == 'GeoLocation'|| customInfo == 'ByCreditSubscription' || customInfo == 'SubscriptionSummary'|| customInfo == 'SubmitSubscription' || customInfo == 'PastSubscriptions' || customInfo == 'UpcomingSubscriptions'|| customInfo == 'SubscriptionUpdate' || customInfo == 'paypal') {
                pageKey = customInfo;
            } else {
                pageKey = key;
            }

            switch (pageKey.toLowerCase()) {
				case 'transactionhistorymigratedwallet':
                    window.open("/gameroom/promo/mobileplaytransactions", "_blank", "");
                  //window.open("/gameroom/promo/extrachances", "_blank", "");
                break;
                case 'terms':
                    window.open("/termsandconditions", "_blank", "");
                    break;

                case 'GeoLocation':
                    window.open("/termsandconditions", "_blank", "");
                    break;

                case 'faq':
                    window.open("/aboutus/FAQ?category=sub_faq","_blank","width=680, height=600, scrollbars=1'");
					break;
					
                case 'pastsubscriptions':
				     window.open("/aboutus/FAQ?category=sub_faq","_blank","width=680, height=600, scrollbars=1'");
					 break;

				case 'upcomingsubscriptions':
				     window.open("/aboutus/FAQ?category=sub_faq","_blank","width=680, height=600, scrollbars=1'");
					 break;

				case 'subscriptionupdate':
					 window.open("/aboutus/FAQ?category=sub_faq","_blank","width=680, height=600, scrollbars=1'");
					 break;
				
                case 'bonuspolicy':
					 window.open("/aboutus/FAQ?category=sub_faq","_blank","width=680, height=600, scrollbars=1'");
                    break;
					
                case 'bycreditsubscription':
				     window.open("/aboutus/FAQ?category=sub_deposit","_blank","width=680, height=600, scrollbars=1'");
				   break;
				   
				case 'subscriptionsummary':
				     window.open("/aboutus/FAQ?category=sub_deposit","_blank","width=680, height=600, scrollbars=1'");
				   break;
				   
				case 'submitsubscription':
				     window.open("/aboutus/FAQ?category=sub_deposit","_blank","width=680, height=600, scrollbars=1'");
				   break;
				
				case 'paypal':
				     window.open("/aboutus/FAQ?category=sub_deposit","_blank","width=680, height=600, scrollbars=1'");
				   break;
				   
                case 'helpdepositmethods':
                     window.open("/aboutus/FAQ?category=sub_deposit","_blank","width=680, height=600, scrollbars=1'");
                    break;

                case 'helpdepositpaymentmethod':
                     window.open("/aboutus/FAQ?category=sub_deposit","_blank","width=680, height=600, scrollbars=1'");
                    break;

                case 'helpdepositpaymentmethodlist':
                     window.open("/aboutus/FAQ?category=sub_deposit","_blank","width=680, height=600, scrollbars=1'");
                    break;

                case 'successfuldeposit':
                     window.open("/aboutus/FAQ?category=sub_deposit","_blank","width=680, height=600, scrollbars=1'");
                    break;

                case 'unsuccessfuldeposit':
                     window.open("/aboutus/FAQ?category=sub_deposit","_blank","width=680, height=600, scrollbars=1'");
                    break;

                case 'claimprizes':
                      window.open("/aboutus/FAQ?category=sub_withdraw","","width=680, height=600, scrollbars=1'");                    
					 break;

                case 'helpcashout':
                      window.open("/aboutus/FAQ?category=sub_withdraw","","width=680, height=600, scrollbars=1'");					  
					 break;

                case 'helpcashouthowto':
                      window.open("/aboutus/FAQ?category=sub_withdraw","","width=680, height=600, scrollbars=1'");                    
					 break;

                case 'helpcashoutpolicy':
                      window.open("/aboutus/FAQ?category=sub_withdraw","","width=680, height=600, scrollbars=1'");                    
					 break;

                case 'play':
                    window.open("/subscribe", "_parent", "");
                    break;

                case 'subscribe':
                    window.open("/subscribe", "_parent", "");
                    break;

                case 'responsiblegaming':
                    window.open("/playresponsibly", "_parent", "");
                    break;

                case '500':
                    //'gamerules,500'  rcw/03/26/20
                    window.open("/Data/Draw-Games/powerball", "_blank", "");
                    break;

                case '502':
                    //'gamerules,502'  rcw/03/26/20
                    window.open("/Data/Draw-Games/MegaMillions", "_blank", "");
                    break;

                case '506':
                    //'gamerules,506'  rcw/03/26/20
                    window.open("/Data/Draw-Games/Cash4Life", "_blank", "");
                    break;

                case '500_1.1':
                    window.open("/Data/Draw-Games/powerball", "_blank", "");
                    break;

                case '502_1.1':
                    window.open("/Data/Draw-Games/MegaMillions", "_blank", "");
                    break;

                    //case 'gamerules':
                    //    window.open("/faq_popup.aspx?keyword=sub_gamerules", "", "width=680, height=600");
                    //    break;
                case '519':
                    window.open("/Data/Draw-Games/Cash5", "_blank", "");
                    break;
		        case '3501':
                    window.open("/Data/Draw-Games/Pick3", "_blank", "");
                    break;
		        case '3502':
                    window.open("/Data/Draw-Games/Pick4", "_blank", "");
                    break;
                case 'bonuses':
                    window.open("/playertools/FAQ?category=playonline-subscriptions", "_blank", "width=680, height=600, scrollbars=1'");
                    break;

                case 'addnewticket':
                    window.open("/subscribe", "_parent", "");
                    break;

                case 'privacy':
                    window.open("/vaprivacystatement", "_blank", "");
                    break;

                case 'bycredit':
                    window.open("/playertools/FAQ?category=playonline-subscriptions", "_blank", "width=680, height=600, scrollbars=1'");
                    break;

                case 'ach-banktransfer':
                    window.open("/playertools/FAQ?category=playonline-subscriptions", "_blank", "width=680, height=600, scrollbars=1'");
                    break;
            }
        });

    });
});


// WEBPACK FOOTER //
// ./shared/components/ng-webportal/webportal.js